export interface AlarmFlags {
    under: number;
    over: number;
    feedbackError: number;
    highHigh: number;
    high: number;
    low: number;
    lowlow: number;
}

export interface ChannelFlags {
    id: string;
    value: number;
    flags: {
        alarm: AlarmFlags;
        cancelAuto1: AlarmFlags;
        cancelAuto2: AlarmFlags;
        cancelAuto3: AlarmFlags;
        cancelManual: AlarmFlags;
        unAck: AlarmFlags;
    };
}

export const REPOSE_LEVEL = 'repose';
export const SENSOR_FAILURE = 'sensor-failure';

export enum FlagOption {
    UNDEFINED = 'undefined',
    HIGH_HIGH = 'highHigh',
    LOW_LOW = 'lowlow',
    HIGH = 'high',
    LOW = 'low',
    NORMAL = 'normal',
    FEEDBACK = 'feedbackError',
    SYSTEM_CHANNEL = 'systemError',
    DIGITAL = 'digital',
    OVER = 'over',
    UNDER = 'under',
}

export class ElementClasses {
    'flag-alarm': boolean;
    'flag-caution': boolean;
    'flag-warning': boolean;
    'flag-cancel': boolean;
    'flag-unack': boolean;
}

export enum ChannelStatus {
    UNDEFINED = 'undefined',
    HIGH = 'High',
    HIGH_HIGH = 'High-High',
    LOW = 'Low',
    LOW_LOW = 'Low-Low',
    NORMAL = 'Normal',
}

export function getStatusString(flagOption: FlagOption, fcuData) {
    if (!fcuData) return '';
    switch (flagOption) {
        case FlagOption.NORMAL:
            return 'NORMAL';
        case FlagOption.HIGH_HIGH:
            return fcuData.alarmSettingVeryHigh.statusString;
        case FlagOption.LOW_LOW:
            return fcuData.alarmSettingVeryLow.statusString;
        case FlagOption.LOW:
            return fcuData.alarmSettingLow.statusString;
        case FlagOption.HIGH:
            return fcuData.alarmSettingHigh.statusString;
        case FlagOption.FEEDBACK:
            return fcuData.alarmSettingFeedbackError.statusString;
        case FlagOption.DIGITAL:
            return fcuData.digitalAlarmSetting.statusString;
        case FlagOption.OVER:
            return fcuData.alarmSettingSensorFail.statusString;
        case FlagOption.UNDER:
            return fcuData.alarmSettingSensorFail.statusString;
        case FlagOption.UNDEFINED:
            return '';
        default:
            return '';
    }
}
